import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { WorseningService } from '../../../services/worsening/worsening.service'
import { UploaderSettings, UploadEntity, mohValidators, ModalService, MessageType, ToggleOption, FormSubmitService } from 'moh-package';
import { WrsWorsening } from '../../../models/worsening/WrsWorsening';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'moh-worsening',
  templateUrl: './worsening.component.html',
  styleUrls: ['./worsening.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class WorseningComponent implements OnInit {
  form: FormGroup;
  worseObj: WrsWorsening;
  medicalDocumentsSettings: UploaderSettings = new UploaderSettings();
  slideToggleOptions: ToggleOption[];
  isFormSubmitted: boolean = false;
  isAddDocDisabled: boolean = false;

  public form_title;
  public title = {
    titleUnderImage: "המרכז הלאומי לפיצוי נפגעי הגזזת", mainImageText: "",
                    mohInfo: "", worseDetailLabel: "", formType: ""
  };



  private idIsNotValid = false;
  private idNotValidMessage = "הערכים שמולאו בשדות : שם פרטי תובעת, שם משפחה תובע/ת,  ומספר זהות אינם מוכרים במרשם אוכלוסין. נא לעדכן ולשלוח שוב."
  private successMessage = "הטופס נשלח בהצלחה למרכז הלאומי לנפגעי גזזת. לבירור לגבי מצב הטיפול בטופס, יש לפנות למוקד הפניות של משרד הבריאות, ולציין את הקוד האישי שקיבלת בעבר ממחלקת גזזת.";
  private failureMessage = "ישנה בעיה בשליחת הטופס. נסה שוב. אם הבעיה חוזרת, יש לפנות למוקד קול הבריאות.";

  constructor(private formBuilder: FormBuilder, private gazzezetService: WorseningService,
    private modal: ModalService, private formSubmitService: FormSubmitService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.initializeFormTitle();

    this.form = this.formBuilder.group({
      ClaimerDetails: [],
      HasAdvocate: [false],
      AdvocateDetails: [],
      WorseDetails: [],
      MedicalDocuments: this.formBuilder.array([new FormControl()], mohValidators.required()),
      Agreement: ['', [mohValidators.requiredTrue()]],
      Recaptcha: []
    });

    this.formSubmitService.errorValidationHandled.subscribe(res => {
      this.isFormSubmitted = true;
    });

    this.slideToggleOptions = [new ToggleOption('כן', true), new ToggleOption('לא', false)];

    this.initializeDocSettings();
  }

  initializeFormTitle() {
    this.form_title = this.route.snapshot.data['form_title'];
    if (this.form_title != null) {
      this.title.formType = this.form_title;

      switch (this.form_title) {
        case "worsening": {//החמרה
          this.title.mainImageText = "בקשה לבדיקה עקב החמרה במצב הרפואי";
          this.title.titleUnderImage = "טופס בקשה לבדיקה עקב החמרה במצב הרפואי";
          this.title.mohInfo = "חובה לצרף לטופס הבקשה מסמכים רפואיים עדכניים המעידים על החמרה במצב הרפואי של המבקש. בקשה ללא מסמכים רפואיים עדכניים לא תטופל.";
          this.title.worseDetailLabel = "פירוט סיבות הגשת הבקשה להחמרה במצב הרפואי (מיום הועדה האחרונה בלבד)";
          break;
        }//ערר
        case "appeal": {
          this.title.mainImageText = "בקשת ערר על החלטת הועדה הרפואית";
          this.title.titleUnderImage = "טופס בקשת ערר על החלטת הועדה הרפואית – להחמרה";
          this.title.mohInfo = "חובה לצרף תיעוד רפואי (סיכום מידע רפואי)";
          this.title.worseDetailLabel = "פירוט סיבות הבקשה לערר (ערר על החלטת הועדה הרפואית האחרונה בלבד)";
          break;
        }//דיון חוזר
        case "rediscussion": {
          this.title.mainImageText = "בקשה לדיון חוזר";
          this.title.titleUnderImage = "טופס בקשה לדיון חוזר";
          this.title.mohInfo = "חובה לצרף ראיות או עדות חדשה (תצהיר)";
          this.title.worseDetailLabel = "פירוט סיבות הבקשה לדיון חוזר (מיום הועדה האחרונה האחרונה)";
          break;
        }
        default: {
          break;
        }
      }//end switch
    }//end if
  }

  initializeDocSettings() {

    this.medicalDocumentsSettings = {

      allowMimeTypes: ['application/pdf', 'image/bmp', 'image/gif', 'image/tiff', 'image/jpeg', 'image/png'],
      maxFileSize: 10 * 1024 * 1024, //10MB
      queueLimit: 1,
      queueMinLimit: 1,
      hasDescription: true,
      isDescriptionRequired: true,
      isMultiple: false,
      isRequired: true,
      isSigned: false
    };
  }

  addMedicalDoc() {

    if (this.form.value["MedicalDocuments"].length < 3) {
      (<FormArray>this.form.controls.MedicalDocuments).push(new FormControl());

      if (this.form.value["MedicalDocuments"].length == 3) {
        this.isAddDocDisabled = true;
      }
    }
  }

  removeMedicalDoc(index) {

    const control = <FormArray>this.form.controls.MedicalDocuments;
    control.removeAt(index);

    if (this.form.value["MedicalDocuments"].length < 3) {
      this.isAddDocDisabled = false;
    }
  }

  toggleAdvocateDetails() {

    if (this.form.controls["HasAdvocate"].value == true) {
      (<FormGroup>this.form).removeControl("AdvocateDetails");
    }
    else {
      this.form.addControl("AdvocateDetails", new FormControl());
    }
  }

  sendWorseningForm() {
   // console.log("form type: " + this.title.formType);
    this.worseObj = new WrsWorsening(this.form.value);

    this.worseObj.IDIsNotValid = this.idIsNotValid;
    this.worseObj.FormType = this.title.formType;
    this.gazzezetService.sendWorseningRequest(this.worseObj).subscribe(

      (res) => {
        this.handleResponse(res);
      },
      (error) => {
        this.modal.errorMsg('', this.failureMessage, 'אישור');
        console.log(error)
      });

  }

  private handleResponse(response) {

    if (!response['statusCode']) {
      this.modal.successMsg('', this.successMessage, 'אישור');
    }

    else if (response['statusCode'] == 404 && !this.idIsNotValid) {

      this.modal.infoMsg('', this.idNotValidMessage, 'אישור', false).then((result) => {

        this.idIsNotValid = true;

      });
    }

    else if (response['statusCode'] == 200 || response['statusCode'] == 404 && this.idIsNotValid) {
      this.modal.successMsg('', this.successMessage, 'אישור');
    }

    else {
      this.modal.errorMsg('', this.failureMessage, 'אישור');
    }
  }
}










// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/worsening/worsening/worsening.component.ts